import {
  getWidgetContainer,
  getRequestId,
  getGreetingElement,
  getInvalidRequestId,
} from '@/components/chatbot/chatbotElementUtils';
import {
  setUpGreetingButtons,
  setUpButtons,
  setUpMinMaxButtons,
  setUpNewUserForm,
  autoScrollToBottom,
} from '@/components/chatbot/chatbotButtonsAndFormsController';
import { showMessagesTemplate } from '@/components/chatbot/chatbotMinMaxButtonsController';
import {
  setupMessageForm,
  initiateSessionTimeoutCheck,
} from '@/components/chatbot/chatbotMessagingController';
import {
  storeUserInformation,
  getUserInformation,
  isIdHashExpired,
  getGreetingView,
  getMinimization,
} from '@/components/chatbot/chatbotConversationPersitenceUtils';

function checkForSessionTimeout() {
  const idHashExpired = isIdHashExpired();

  if (idHashExpired) {
    clearInterval(window.solvCheckForSessionTimeout);
    window.solvCheckForSessionTimeout = null;
    window.localStorage.removeItem('solvChatId');
    reinitializeWidget();
  }
}

async function reinitializeWidget() {
  const testURLElement = document.getElementById('testing-chatbot-locally');
  let resetUrl = 'https://www.solvhealth.com/dir/chatbot-new-session';
  if (testURLElement) {
    resetUrl = '/dir/chatbot-new-session';
  }

  const userInformation = getUserInformation();
  const oldRequestId = getRequestId();

  const res = await fetch(
    `${resetUrl}?user_information=${userInformation}&request_id=${oldRequestId}`,
  );
  const data = await res.json();
  const requestId = data.request_id;

  const widgetContainer = document.querySelector('solv-chatbot-widget');
  widgetContainer.dataset.requestId = requestId;

  await loadWidgetInitialContent();
}

async function loadWidgetInitialContent() {
  let requestId = getRequestId();
  const invalidRequestId = getInvalidRequestId();

  const testURLElement = document.getElementById('testing-chatbot-locally');
  let templateURL = 'https://www.solvhealth.com/dir/chatbot-widget-template';
  if (testURLElement) {
    templateURL = '/dir/chatbot-widget-template';
  }

  const userInformation = getUserInformation();
  const greetingView = getGreetingView();
  const minimizationTime = getMinimization();

  let url = `${templateURL}?request_id=${requestId}&user_information=${userInformation}`;
  if (greetingView) {
    url += `&greeting_view=${greetingView}`;
  }
  if (invalidRequestId && invalidRequestId != requestId) {
    url += `&invalid_request_id=${invalidRequestId}`;
  }

  // If the user has previously minimized the widget, we check if the minimization time is within the last hour. If it is, we may keep the widget minimized
  if (minimizationTime) {
    url += `&minimized=${minimizationTime}`;
  }

  const res = await fetch(url);
  const data = await res.json();
  const template = data.content;
  const newUserInformation = data.user_information;
  if (newUserInformation != userInformation) {
    storeUserInformation(newUserInformation);
  }

  const container = getWidgetContainer();
  container.innerHTML = template;

  const greetingTemplate = getGreetingElement();
  if (greetingTemplate) {
    setUpGreetingButtons();
  } else {
    initiateSessionTimeoutCheck();
    showMessagesTemplate();
  }
  setUpButtons();
  setUpMinMaxButtons();
  setupMessageForm();
  autoScrollToBottom();
  setUpNewUserForm();
}

export { loadWidgetInitialContent, checkForSessionTimeout };
